<div class="card shadow-lg rounded-4 mb-1">
    <div class="card-body p-3">
        <!-- Month Navigation & Year Selectors -->
        <div class="d-flex justify-content-between align-items-center mb-3">
            <div *ngIf="showLegends">
                <span class="me-2"><i class="bi bi-circle-fill text-success"></i> Present</span>
                <span class="me-2"><i class="bi bi-circle-fill text-danger"></i> Absent</span>
                <span class="me-2"><i class="bi bi-circle-fill text-warning"></i> Meetings</span>
                <span><i class="bi bi-circle-fill text-info"></i> Leave</span>
            </div>


            <div class="d-flex align-items-center ms-auto">
                <button class="btn btn-light rounded-4 btn-sm me-2" (click)="onMonthChange(currentMonth - 1)">
                    <i class="bi bi-caret-left-fill"></i>
                </button>

                <!-- Month Dropdown -->
                <select class="form-select form-select-sm rounded-pill me-2" [(ngModel)]="currentMonth"
                    (ngModelChange)="onMonthChange($event)" [disabled]="isNavigationDisabled">
                    <option *ngFor="let month of monthsWithNumbers" [value]="month.number">
                        {{ month.name }}
                    </option>
                </select>

                <!-- Year Dropdown -->
                <select class="form-select form-select-sm rounded-pill me-2" [(ngModel)]="currentYear"
                    (ngModelChange)="onYearChange($event)" [disabled]="isNavigationDisabled">
                    <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                </select>

                <button class="btn btn-light rounded-4 btn-sm me-2" (click)="onMonthChange(currentMonth + 1)">
                    <i class="bi bi-caret-right-fill"></i>
                </button>
            </div>
        </div>

        <!-- Calendar Container -->
        <div class="calendar-container card rounded-4 p-2 mb-0">
            <div class="calendar-grid">
                <div class="day-name" *ngFor="let dayName of ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']">
                    {{ dayName }}
                </div>

                <!-- Empty Placeholders -->
                <div class="day empty" *ngFor="let i of getEmptyPlaceholders()"></div>

                <!-- Calendar Days -->
                <div *ngFor="let day of calendarDays" class="day" (click)="dayClick(day) "
                    [class.isWeekend]="day.isWeekend == 1 && day.isWorkingDay != 1" 
                    [class.isPresent]="isPresent(day)"
                    [class.isHoliday]="day.isHoliday == 1" 
                    [class.selected]="isSelected(day)"
                    [class.today-dot]="isToday(day) && getTodayHighlightStyle() === 'dot'"
                    [class.today-underline]="isToday(day) && getTodayHighlightStyle() === 'underline'"
                    [class.today-border]="isToday(day) && getTodayHighlightStyle() === 'border'" 
                    [class.today-fill]="isToday(day) && getTodayHighlightStyle() === 'fill'"
                    [class.disabled-day]="!canClickFutureDate(day)"
                    [class.needsRG-border]="giveOrangeBorder(day)" 
                    [class.needsRG-minus-hover]="isSelected(day)"
                    [class.showTimeIcon]="giveTimeIcon(day)" 
                    [class.showTickMark]="giveTickMark(day)"
                    [class.showCrossMark]="giveCrossMark(day)"
                    [ngClass]="{ 'has-meeting': getIndicatorCountForDay(day)}"
                    [ngClass]="{ 'has-meeting': getIndicatorCountForDay(day)}">

                    <span>{{ day.day }}</span>
                    <div *ngIf="day.isHoliday == 1" class="holiday-container">
                        <span class="holiday-bar"></span>
                        <span class="holiday-note">{{ day.description }}</span>
                    </div>

                    <!--INITIALS USERNAME-->
                    <div class="initialsUserIcons" *ngIf="showInitialUserIcons">
                        <div *ngIf="giveUserIcons(day)" class="user-icon-container">

                            <div class="user-icons">
                                <!-- Loop through the usernames for the day (limited to 2 users + +X if needed) -->
                                <div *ngFor="let user of getUserNamesForDayWithLimit(day); let i = index" style="font-weight: 700; font-size:0.5rem; color: white;"
                                    class="user-icon" [style.background-color]="getUserColor(user)"
                                    [ngClass]="{ 'extra-user-icon': user.includes('+') }"
                                    [ngbTooltip]="getToolTipForDay(day)" container="body" tooltipClass="custom-tooltip">

                                    <span class="initials" *ngIf="!user.includes('+')">
                                        {{ getInitials(user) }}
                                    </span>

                                    <!-- Show "+X" for extra users -->
                                    <span *ngIf="user.includes('+')" class="extra-users" style="font-weight: 700; font-size:0.6rem; color: rgb(44, 42, 42);">{{ user }}</span>
                                </div>
                            </div>
                        </div>
                    </div>


                    <!-- Tooltip container for meetings -->
                    <div *ngIf="getIndicatorCountForDay(day) !== null" class="tooltip-container">
                        <div class="meeting-dot">
                            <span>{{ getIndicatorCountForDay(day) }}</span> <!-- Meeting count -->
                        </div>

                        <!-- Custom tooltip with meeting data -->
                        <div class="tooltip" *ngIf="getMeetings(day).length">
                            <div *ngFor="let meeting of getMeetings(day); let i = index">
                                <div class="tooltip-item">
                                    <strong>{{ i + 1 }}.</strong> {{ meeting }}
                                </div>
                            </div>
                        </div>

                        <!-- <div class="day-icons">
                        <i *ngIf="day.isWorkingDay" class="bi bi-circle-fill text-success"></i>
 
                        <i *ngIf="day.isHoliday" class="bi bi-circle-fill text-danger"></i>
                    </div> -->
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
<div class="notification-banner px-1 py-1 rounded-4 text-dark d-flex justify-content-between align-items-center"
    [ngClass]="{ 'notification-slide-down': showNotification, 'notification-slide-up': !showNotification }">
    <span class="text-secondary">
        <i class="bi bi-lightbulb mx-1 text-warning"></i>
        {{notificationMsg.notiMsg}}
    </span>
    <button class="btn btn-sm btn-outline-warning rounded-pill" (click)="notiBtnClick()">
        {{notificationMsg.notiBtnMsg}}
    </button>
</div>